import { Helmet } from 'react-helmet';
import {
  Box,
  Container,
  Grid,
  OutlinedInput,
  TableCell,
  TableContainer,
  TableBody,
  TableHead,
  TableRow,
  Table,
  Divider,
  Button,
  Card,
  CardContent,
  TextField,
  CardHeader,
  CircularProgress
} from '@mui/material';
import PerfectScrollbar from 'react-perfect-scrollbar';
import VerticalBarGraph from 'src/components/pages/ahc/ahcDashboard/VerticalBarGraph';
import React, { Component } from 'react';
import RequestChart from 'src/components/pages/vaccination/dashboard/RequestChart';
import StatusCount from 'src/components/pages/vaccination/dashboard/StatusCount';
import masterStatus from 'src/models/medicine';
import Traffic from 'src/components/pages/vaccination/dashboard/TrafficByType';
import moment from 'moment';
import * as _ from 'lodash';
import theme from 'src/theme';
import Report from '@mui/icons-material/Report';
import Beenhere from '@mui/icons-material/Beenhere';
import Cancel from '@mui/icons-material/Cancel';
import PermContactCalendarIcon from '@mui/icons-material/PermContactCalendar';
import OfflinePin from '@mui/icons-material/OfflinePin';
import commonService from 'src/service/common';
import goodalipi from 'src/plugins/goodalipi';
import Count from 'src/components/pages/ahc/ahcEmployees/count';
import { Bar } from 'react-chartjs-2';
const masterStatusCount = JSON.parse(JSON.stringify(masterStatus));
import { _axios } from 'src/plugins/axios';
import axios from 'axios';

const iconMapping = {
  AttendedCount: <Beenhere fontSize="large" style={{ color: 'white' }} />,
  CanceledCount: <Cancel fontSize="large" style={{ color: 'white' }} />,
  ConfirmedCount: <OfflinePin fontSize="large" style={{ color: 'white' }} />,
  NewAppointmentCount: (
    <PermContactCalendarIcon fontSize="large" style={{ color: 'white' }} />
  ),
  NotAttendedCount: <Report fontSize="large" style={{ color: 'white' }} />
};

const daysToPreFetch = 30;

class WalletDashboard extends Component {
  constructor(props) {
    super(props);
    this.state = {
      entityRequested: goodalipi.get('globalHRgroup')
        ? goodalipi.get('globalHRgroup')
        : [],
      empId: '',
      CorpWallet: false,
      MAWallet: false,
      MBWallet: false,
      corpWalletHistory: [],
      MAWalletHistory: [],
      MBWalletHistory: [],
      activeTable: 1,
      activeTabledata: [],
      activeTabledataa: [],
      calledWalletApi: false,
      isLoading: false
    };
    this.DeliveryType = React.createRef();
    this.ageWiseRef = React.createRef();
  }

  walletdetails() {
    this.setState({ isLoading: true });
    let payload = {
      empId: this.state.empId
    };
    _axios
      .post('transactions/walletHistory', payload, {
        ignoreLoading: true,
        headers: {
          authtoken: commonService.getAuthToken(),
          'Content-Type': 'application/json'
        }
      })
      .then((res) => {
        this.setState({ isLoading: false, calledWalletApi: true });
        if (
          res.data.BalanceSheet.CorpWallet &&
          res.data.BalanceSheet.CorpWallet != []
        ) {
          this.setState({ CorpWallet: true });
          this.setState({
            corpWalletHistory: res.data.BalanceSheet.CorpWallet,
            activeTabledata: res.data.BalanceSheet.CorpWallet
          });
        }
        if (
          res.data.BalanceSheet.MBWallet &&
          res.data.BalanceSheet.MBWallet != []
        ) {
          this.setState({
            MBWalletHistory: res.data.BalanceSheet.MBWallet,
            MBWallet: true
          });
        }
        if (res.data.Ledger) {
          let MAWalletTransactionsVariable = [];
          res.data.Ledger.forEach(function (order) {
            order.Requests.forEach(function (request) {
              //if for the given request, walletDeductionInfo exists?
              if (request.walletDeductionInfo) {
                request.walletDeductionInfo.forEach(function (deduction) {
                  if (deduction.walletName == 'MAWallet') {
                    MAWalletTransactionsVariable.push({
                      productName: request.productName,
                      payableAmount: deduction.payableAmount,
                      transactionType: 'DEBIT', //all MAWallet are debit
                      orderDate: request.OrderDate,
                      requestId: request.RequestId,
                      orderId: order.OrderId
                    });
                  }
                });
              }

              //if request.walletDeductionInfo doesn't exist and no. of requests is 1, go to unmapped deductions
              else if (!request.walletDeductionInfo && request.length === 1) {
                order.UnmappedDeductions.forEach(function (deduction) {
                  if (deduction.deductionSource === 'MAWallet') {
                    MAWalletTransactionsVariable.push({
                      productName: request.productName,
                      payableAmount: deduction.amount,
                      transactionType: 'DEBIT',
                      orderDate: request.OrderDate,
                      requestId: request.RequestId,
                      orderId: order.OrderId
                    });
                  }
                });
              }
            });
          });
          if (MAWalletTransactionsVariable != [])
            this.setState({
              MAWallet: true,
              MAWalletHistory: MAWalletTransactionsVariable
            });
        }
      })
      .catch((err) => {
        this.setState({ isLoading: false, calledWalletApi: true });
        console.log(err);
      });
  }

  componentDidMount() {
  }

  componentDidCatch() {
    console.log('test');
  }

  mbWalletTable(walletHistory) {
    return (
      <>
        <TableHead>
          <TableRow>
            <TableCell>Date</TableCell>
            <TableCell>Description</TableCell>
            <TableCell>Debit (in ₹)</TableCell>
            <TableCell>Credit (in ₹)</TableCell>
            <TableCell>Balance (in ₹)</TableCell>
          </TableRow>
        </TableHead>
        <TableBody>
          {[...walletHistory].reverse().map((transaction) => (
            <TableRow hover>
              <TableCell>
                { transaction.Createdon?
                transaction.Createdon.slice(0, 10): 'N/A'}
              </TableCell>
              <TableCell>
                {transaction.OrderId
                  ? `${transaction.CustomOrderDetail} Order ID - ${transaction.OrderId}`
                  : 'MediBuddy Support'}
              </TableCell>
              <TableCell>
                {transaction.TransactionAmount
                  ? transaction.TransactionType == 'DEBIT'
                    ? transaction.TransactionAmount.toFixed(2)
                    : 0.0
                  : transaction.Corp_TransactionType == 'DEBIT'
                  ? transaction.Corp_TransactionAmount.toFixed(2)
                  : 0.0}
              </TableCell>
              <TableCell>
                {transaction.TransactionAmount
                  ? transaction.TransactionType == 'CREDIT'
                    ? transaction.TransactionAmount.toFixed(2)
                    : 0.0
                  : transaction.Corp_TransactionType == 'CREDIT'
                  ? transaction.Corp_TransactionAmount.toFixed(2)
                  : 0.0}
              </TableCell>
              <TableCell>{transaction.FinalBalance.toFixed(2)}</TableCell>
            </TableRow>
          ))}
        </TableBody>
      </>
    );
  }

  maWalletTable(walletHistory) {
    console.log(walletHistory)
    return (
      <>
        <TableHead>
          <TableRow>
            <TableCell>Date</TableCell>
            <TableCell>Description</TableCell>
            <TableCell>Debit (in ₹)</TableCell>
          </TableRow>
        </TableHead>
        <TableBody>
          {[...walletHistory].reverse().map((transaction) => (
            <TableRow hover>
              <TableCell>{transaction.OrderDate? transaction.orderDate.slice(0, 10): 'N/A'}</TableCell>
              <TableCell>{transaction.productName}</TableCell>
              <TableCell>{transaction.payableAmount}</TableCell>
            </TableRow>
          ))}
        </TableBody>
      </>
    );
  }
  activateTabel(num) {
    if (num == 1) {
      this.setState({
        activeTabledata: this.state.corpWalletHistory,
        activeTable: 1
      });
    } else if (num == 2) {
      this.setState({
        activeTabledata: this.state.MAWalletHistory,
        activeTable: 2
      });
    } else {
      this.setState({
        activeTabledata: this.state.MBWalletHistory,
        activeTable: 3
      });
    }
  }
  displayTable(data) {
    if (this.state.isLoading) {
      return <CircularProgress sx={{margin:'5%', marginLeft: '40%' }} size={100} />;
    }
    if (!this.state.calledWalletApi) {
      return (
        <>
          <div style={{ margin: '2%', textAlign: 'center', fontSize: 20 }}>
            Please enter employee Id and get wallet utilization
          </div>
        </>
      );
    }
    if (data.length == 0) {
      return (
        <>
          <div style={{ margin: '5%' }}>
            There isn't any transaction in selected wallet
          </div>
        </>
      );
    }
    if (this.state.activeTable == 2) {
      return this.maWalletTable(data);
    }
    return this.mbWalletTable(data);
  }

  render() {
    return (
      <>
        <Helmet>
          <title>Wallet | Dashboard</title>
        </Helmet>
        <Box
          sx={{
            backgroundColor: 'background.default',
            minHeight: '100%',
            py: 2
          }}
        >
          <Container maxWidth={false}>
            <Grid container alignItems="stretch" spacing={2}>
              <Grid item container lg={12} xs={12}>
                <Card
                  sx={{
                    width: '100%',
                    borderRadius: 4,
                    mb: 0,
                    pt: 2,
                    boxShadow: '0 0 4px rgba(0,0,0,0.15)'
                  }}
                >
                  <CardContent>
                    <Grid item mt={5}>
                      <label
                        style={{
                          textAlign: 'left',
                          margin: '2%'
                        }}
                      >
                        Employee Id
                      </label>
                      <OutlinedInput
                        id="outlined-search"
                        sx={{
                          boxShadow: 0,
                          bgcolor: '#f2f2f2',
                          marginBottom: '3%',
                          marginLeft: '5%'
                          // alignSelf: 'center'
                        }}
                        labelWidth={0}
                        value={this.state.empId}
                        onChange={(ev) => {
                          this.setState({ empId: ev.target.value });
                        }}
                        placeholder={`Entity Id`}
                      />
                      <Button
                        sx={{
                          width: '25%',
                          marginLeft: '5%',
                          marginTop: '2%',
                          marginBottom: '3%',
                          boxShadow: '0 0 4px rgba(0,0,0,0.20)',
                          backgroundColor: '#143a72',
                          color: 'white'
                        }}
                        onClick={() => this.walletdetails()}
                      >
                        Submit
                      </Button>
                      <br />
                      {this.state.CorpWallet ? (
                        <Button
                          sx={{
                            width: '25%',
                            marginLeft: '5%',
                            marginTop: '2%',
                            marginBottom: '3%',
                            boxShadow: '0 0 4px rgba(0,0,0,0.20)',
                            backgroundColor: '#143a72',
                            color: 'white'
                          }}
                          onClick={() => this.activateTabel(1)}
                        >
                          Corp Wallet
                        </Button>
                      ) : (
                        ''
                      )}
                      {this.state.MAWallet ? (
                        <Button
                          onClick={() => this.activateTabel(2)}
                          sx={{
                            width: '25%',
                            marginLeft: '5%',
                            marginTop: '2%',
                            marginBottom: '3%',
                            boxShadow: '0 0 4px rgba(0,0,0,0.20)',
                            backgroundColor: '#143a72',
                            color: 'white'
                          }}
                        >
                          MA Wallet
                        </Button>
                      ) : (
                        ''
                      )}
                      {this.state.MBWallet ? (
                        <Button
                          onClick={() => this.activateTabel(3)}
                          sx={{
                            width: '25%',
                            marginLeft: '5%',
                            marginTop: '2%',
                            marginBottom: '3%',
                            boxShadow: '0 0 4px rgba(0,0,0,0.20)',
                            backgroundColor: '#143a72',
                            color: 'white'
                          }}
                        >
                          MB Wallet
                        </Button>
                      ) : (
                        ''
                      )}
                      <TableContainer sx={{ maxHeight: 500 }}>
                        <Table
                          stickyHeader
                          aria-label="Employee list"
                          id="employee-list"
                        >
                          {this.displayTable(this.state.activeTabledata)}
                        </Table>
                      </TableContainer>
                    </Grid>
                  </CardContent>
                </Card>
              </Grid>
            </Grid>
          </Container>
        </Box>
      </>
    );
  }
}
export default WalletDashboard;
